import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCU0HU7Pp__xU7FLnhbDUofcDM19aZ5tCQ",
  authDomain: "menu-b385e.firebaseapp.com",
  projectId: "menu-b385e",
  storageBucket: "menu-b385e.firebasestorage.app",
  messagingSenderId: "814616029268",
  appId: "1:814616029268:web:8f8cdeb0bf0df984e865c1"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
